import React, { useRef } from 'react';
import { cn } from '../../../utils/cn';

interface GridProps extends React.PropsWithChildren {
    colClasses?: string;
    rowsGapClass?: string;
    className?: string;
}

export const Grid = React.forwardRef<HTMLDivElement, GridProps>(
    (props, ref) => {
        const {
            children,
            colClasses = 'grid-cols-1',
            rowsGapClass,
            className,
        } = props;

        const innerRef = useRef<HTMLDivElement>(null);
        const gridRef = ref || innerRef;

        return (
            <div
                ref={gridRef}
                className={cn(
                    'grid gap-6',
                    colClasses,
                    rowsGapClass,
                    className,
                )}
            >
                {children}
            </div>
        );
    },
);

Grid.displayName = 'Grid';
